import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { formatNumber } from '~/lib';
import { PlanType, ServiceType } from '~/types/subscriptionTypes';
import PlanCardWrapper from '~/pages/Subscription/PlanCardWrapper';
import { getSubscriptionServices, sendGTMEvent } from '~/utils';
import { useFullRoutes } from '~/hooks';
import { useState } from 'react';
import { Icon } from '@aqarmap/aqarmap-ui';

export default function PlanCard({ plan }: { plan: PlanType }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('app');
  const { SUBSCRIPTION_URL } = useFullRoutes();
  const locale = i18n.language;
  const services = getSubscriptionServices(plan);
  const [checkedIndex, setCheckedIndex] = useState<number>(-1);
  const allowAccordion = (service: ServiceType) =>
    service?.service?.description;
  const packageCredit = plan?.subscription_plan_package[0]?.package?.credit;
  const hasListingCredit =
    plan?.subscription_plan_package.length > 0 &&
    packageCredit !== null &&
    packageCredit !== undefined;

  const duration = Number(plan.duration_days) / 30;
  const fees = `${formatNumber(Number(plan.price))} ${t('egp')}/${duration === 1 ? ` ${t('month')}` : ` ${duration} ${t('months')}`}`;

  return (
    <PlanCardWrapper plan={plan}>
      <p className="text-title-4 flex gap-x">
        {plan.price_before_discount && (
          <span className="line-through text-[#666666E5]">
            {formatNumber(Number(plan.price_before_discount))} {t('egp')}
          </span>
        )}
        <span>{fees}</span>
      </p>
      <ul className="flex flex-col gap-2x">
        {hasListingCredit ? (
          <li
            className={`service-ite flex gap-x items-center ${locale === 'ar' ? 'ar' : ''}`}
          >
            <Icon
              name="check"
              className="bg-green_light w-[24px] h-[24px] text-white rounded-full"
            />
            <p className="!text-link !text-black">
              {t('pointsValue', {
                value: formatNumber(packageCredit),
              })}
            </p>
            <span className="text-body_1 text-gray__dark_2">
              ({t('toAddListings')})
            </span>
          </li>
        ) : (
          <></>
        )}
        {services.map((planService, index) => {
          return (
            <li
              key={`service-${Math.random()}`}
              className={`rounded-[0px] ${allowAccordion(planService) ? 'collapse' : ''} `}
              onClick={() =>
                setCheckedIndex((prev) => (prev === index ? -1 : index))
              }
            >
              <input
                type="radio"
                name="plan-services"
                checked={index === checkedIndex}
                hidden
              />
              <div className={`service-item  ${locale === 'ar' ? 'ar' : ''}`}>
                <div className="flex w-full justify-between items-start collapse-title  min-h-[24px] !p-0">
                  <p className="text-body_1 text-gray__dark_2">
                    {planService.service.title}
                  </p>
                  {allowAccordion(planService) && (
                    <div className={index === checkedIndex ? 'rotate-180' : ''}>
                      <Icon name="chevron-down" className="cursor-pointer" />
                    </div>
                  )}
                </div>
              </div>
              {allowAccordion(planService) && index === checkedIndex && (
                <div className="collapse-content !p-x  bg-gray_light_1 rounded-[0] mt-1.5x">
                  <p className="text-caption text-gray__dark_2">
                    {planService.service.description}
                  </p>
                </div>
              )}
            </li>
          );
        })}
      </ul>

      <div className="flex flex-col gap-1.5x">
        {!hasListingCredit && (
          <div className="rounded-[8px] bg-[#E50C0C0D] py-x text-center ">
            <p className="text-caption-1 text-red_dark">
              {t('noPropertyListing')}
            </p>
          </div>
        )}
        {plan?.has_trial && plan.trial_days && (
          <button
            onClick={() => {
              sendGTMEvent({
                event: 'gtm-subscription_plan',
                subscription_type: 'free_trial',
                plan_id: plan.id.toString(),
              });
              navigate(`${SUBSCRIPTION_URL.CHECKOUT(plan.id)}?trial=true`);
            }}
            className="btn-tertiary btn-medium rounded-[26px] element-center "
          >
            <Trans
              t={t}
              i18nKey="freeTrialDays"
              values={{
                days: plan.trial_days,
              }}
            />
          </button>
        )}
        <button
          onClick={() => {
            sendGTMEvent({
              event: 'gtm-subscription_plan',
              subscription_type: 'subscribe',
              plan_id: plan.id.toString(),
            });
            navigate(SUBSCRIPTION_URL.CHECKOUT(plan.id));
          }}
          className="btn-primary btn-medium rounded-[26px] element-center "
        >
          {t('subscribeNow')}
        </button>
      </div>
    </PlanCardWrapper>
  );
}
